import { JSX } from 'preact/compat'

type Props = {
  children: JSX.Element
}

const Embed = (props: Props) => (
  <div className="wf_reset wf_container wf_embed_wrapper">
    <div className="wf_reset wf_box wf_embed_box">{props.children}</div>
  </div>
)

export default Embed
